import React from 'react'
import { If } from '@paytrace/pt-skel/Component'
import { EDInfoIcon } from '../../../../Component/Icons'
import * as EDT from '../../../../Type/EnhancedData'
import { LineItemsTable } from './LineItemTable'
import { EDTotalsFeedback } from '../../../../Component/EnhancedData/EDResponseFeedbacks'

export function ProductLineItemDataContainer (props: EDT.L3SectionProps): React.JSX.Element {
  return (
    <div className="product-line-item-data-container">
      <h1 style={{ color: 'black' }}>Product Line Item Data</h1>
      <div className="warning enhanced-data-warning">
        <EDInfoIcon />
        <span>
          For <strong>Level 3</strong> transactions, adding line items <strong>that match the transaction total</strong> may help you qualify for better processing rates. For <strong>Levels 1 & 2</strong>, at least one line item is required when updating summary-level data.
          <br/><br/>
          The maximum number of product line items per transaction is 301.
        </span>
      </div>
      {/* TODO: show a confirmation pop-up right before submitting L3 request without line-items */}
      <If is={props.showTotalMismatchBanner}>
        <EDTotalsFeedback content={props.totalsMismatchMessageContent}/>
      </If>
      <LineItemsTable {...props} />
      <If is={props.showTotalMismatchBanner}>
        <EDTotalsFeedback content={props.totalsMismatchMessageContent}/>
      </If>
    </div>
  )
}
